import { useContext, useEffect, useState } from "react";
import axios from "axios";

import CustomScrollbar from "../../UI/Scrollbar/CustomScrollbar";
import MessageField from "../../UI/MessageField/MessageField";
import DeviceContext from "../../store/device-context";
import Loader from "../../components/loader/Loader";
import getHost from "../../store/host-store";
import FAQNavigation from "./FAQNavigation";
import style from "./style.module.sass";
import { token } from "../../App";
import Dialog from "./Dialog";
import Header from "./Header";
import moment from "moment";
import { Helmet } from "react-helmet";
import AuthContext from "../../store/auth-context";

const Support = () => {
    const [mesagges, setMessages] = useState([]);
    const [serverTime, setServerTime] = useState()
    const [showMessage, setShowMessage] = useState(false)
    const [textInput, setTextInput] = useState("");
    const [attachedFiles, setAttachedFiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const disabled = textInput === "" && attachedFiles.length === 0;
    const device = useContext(DeviceContext);
    const {rerender} = useContext(AuthContext)

    const fetchChatMessages = () => {
        // Получаем сообщения после первой загрузки стр
        fetch(
            getHost({
                controller: "chat-message",
                action: "user-messages",
                expand: "files",
            }),
            {
                headers: {
                    Accept: "application/json",
                    Authorization: token,
                },
            }
        )
            .then((res) => res.json())
            .then((result) => {
                setLoading(false);
                if (result.success) {
                    setMessages(getDates(result.data.messages));
                    setServerTime(result.data.server_time)
                } else {
                    if (result.status === 401) {
                        localStorage.removeItem("token");
                        window.location.replace("/login");
                    }
                }
            })
            .catch((error) => console.log(error));
    };

    // Отправка сообщения в поддержку
    const sendMessage = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("text", textInput);

        if (attachedFiles.length > 0) {
            attachedFiles.forEach((file) => formData.append("file[]", file));
        }

        try {
            const res = await axios.post(
                getHost({ controller: "chat-message" }),
                formData,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: token,
                    },
                }
            );

            // очистка формы
            setTextInput("");
            // обновляем список сообщений
            fetchChatMessages();
            // очищаем выбранные изображения
            setAttachedFiles([]);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (!serverTime) return;

        const date = new Date(serverTime.replace(' ', 'T'));
        const hours = date.getHours();

        const isSupportOpen = hours >= 22 || hours < 6;

        setShowMessage(isSupportOpen);

    }, [serverTime]);

    useEffect(() => {
        fetchChatMessages();
    }, [rerender]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function getDates(messageList) {
        const data = messageList;
        const result = {};
        Object.values(data).forEach((item) => {
            const date = moment(item.created).format("DD.MM.YYYY");
            if (!result[date]) {
                result[date] = [];
            }
            result[date].push(item);
        });

        return result;
    }

    return (
        <div className="cabinet__redesign_container">
            <h3 className="cabinet__redesign_title">Служба поддержки</h3>
            <Helmet>
                <title>Техническая поддержка сервиса «CityWork»</title>
                <meta
                    name="description"
                    content="Техническая поддержка сервиса «CityWork» — онлайн-агрегатора услуг в строительной отрасли без посредников в Москве.
                 Поиск исполнителей и заказчиков строительных работ в Москве."
                />
            </Helmet>
            <div className={style.support}>
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        <Header />
                        <FAQNavigation />
                        {device.isMobile ? (
                            <CustomScrollbar style={{ height: 400 }}>
                                <div className={style.dialog}>
                                    <Dialog data={mesagges} />
                                </div>
                            </CustomScrollbar>
                        ) : (
                            <CustomScrollbar style={{ height: 580 }}>
                                <div className={style.dialog}>
                                    <Dialog data={mesagges} />
                                </div>
                            </CustomScrollbar>
                        )}
                        <div className={style.messageField}>
                            {
                                showMessage &&
                                <p className={style.infoText}>
                                    Здравствуйте! Сейчас мы не можем ответить оперативно на ваше сообщение, так как наша поддержка работает с 6:00 до  22:00 (МСК).
                                    Если вопрос срочный, вы можете обратиться к разделу «Часто задаваемые вопросы
                                </p>
                            }
                            <MessageField
                                textInput={textInput}
                                onTextChange={setTextInput}
                                onSendMessage={sendMessage}
                                onFilesChange={setAttachedFiles}
                                attachedFiles={attachedFiles}
                                disabled={disabled}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Support;
